module.exports = __webpack_public_path__ + "static/media/approval.f50a84db.svg";